import { useEffect } from 'react'

/**
 * Toggles a classname on the body element.
 * @param className
 */
export function useBodyClassName(className: string | null) {
  useEffect(() => {
    if (!className) {
      return
    }

    const alreadyHasClassName = document.body.classList.contains(className)
    if (alreadyHasClassName) {
      return
    }

    document.body.classList.add(className)
    return () => {
      document.body.classList.remove(className)
    }
  }, [className])
}
